import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"

export const fetchStates = createAsyncThunk('states/fetchStates', async ({
                                                                        searchQuery,
                                                                      }, { rejectWithValue }) => {
  try {

    const response = await apiRequest.get('/states')
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch contacts'
    return rejectWithValue(errorMessage)
  }
})